import { navStateStore } from "../state/nav-state-store";
import { UserInformation } from "../entities/user-information";
import { NaviError, NaviErrorTypes } from "../utility/navi-error";
import { getConfig, getString } from "../utility/helper";
import { Statuscodes } from "../utility/constants/statuscodes";

export async function getUserInformation(
  accessToken: string,
  locale: string,
): Promise<UserInformation> {
  const config = getConfig(navStateStore.state.env);
  const init = {
    method: "GET",
    headers: {
      "X-Trace-Id": crypto.randomUUID(),
      Authorization: `${accessToken}`,
      Accept: "application/json",
      Env: navStateStore.state.env,
    },
  };

  let response: Response;

  try {
    response = await fetch(
      getString(`${config?.BFF_ENDPOINT}/user-information?locale=${locale}`),
      init,
    );
  } catch (err) {
    const errorMessage = `Get User information request failed in Frontend with error: ${JSON.stringify(
      (err as Error).message,
    )}`;
    throw new NaviError(errorMessage, NaviErrorTypes.GENERAL);
  }
  if (response.status === Statuscodes.unauthorized) {
    throw new NaviError("AccessToken has expired", NaviErrorTypes.UNAUTHORIZED);
  }

  if (!response.ok) {
    const errorMessage = `Get User information request failed in Frontend with error: ${response.status} ${response.statusText}`;
    throw new NaviError(errorMessage, NaviErrorTypes.GENERAL);
  }

  return response.json();
}
